/**
 * Dependencies
 */
import { addResize } from '../utils/breakpoints'

/**
 * Toggle controller
 */
export default class {
  constructor(el, options) {
    const Expander = this
    this.el = el
    this.targetEl = document.getElementById(options.target)

    if (this.targetEl) {
      this.targetEl.setAttribute('data-height', this.targetEl.offsetHeight)
      this.targetEl.style.height = '0'
      this.targetEl.style.minHeight = ''

      el.setAttribute('aria-expanded', 'false')
      el.setAttribute('aria-haspopup', 'true')
      el.setAttribute('aria-controls', this.targetEl.id)

      el.addEventListener('click', this, false)
      el.addEventListener('keydown', this, false)

      addResize(() => {
        window.requestAnimationFrame(Expander.recalcTarget.bind(Expander))
      })
    }
  }

  /**
   * onKeydown
   * @param {Object} e
   */
  handleEvent(e) {
    if (!e.key || e.key === 'Enter' || e.key === ' ') {
      this.expandElement()
    }

    e.preventDefault()
  }

  expandElement(newState) {
    newState = typeof newState === 'boolean' ? newState : !this.isExpanded()

    this.targetEl.style.minHeight = newState
      ? this.targetEl.getAttribute('data-height') + 'px'
      : ''

    this.targetEl.setAttribute('aria-hidden', !newState)
    this.el.setAttribute('aria-expanded', newState)
  }

  isExpanded() {
    return this.el.getAttribute('aria-expanded') === 'true'
  }

  recalcTarget() {
    this.targetEl.style.visibility = 'hidden'
    this.targetEl.style.display = 'block'
    this.targetEl.style.height = ''
    this.targetEl.style.minHeight = ''

    const newHeight = this.targetEl.offsetHeight

    this.targetEl.setAttribute('data-height', newHeight)
    this.targetEl.style.minHeight = this.isExpanded() ? newHeight + 'px' : ''

    this.targetEl.style.height = '0'
    this.targetEl.style.visibility = ''
    this.targetEl.style.display = ''
  }
}
